<div class="af-header">
  <div class="af-header-left">
    <span>
        <a href="https://www.autoform.com/{{translationService.getLanguage()}}/" target="_blank"><img src="assets/af-logo.webp"
                        alt="Logo"
                        class="logo"></a>
    </span>
  </div>
  <div class="af-header-right">
    <af-dropdowns></af-dropdowns>
  </div>
</div>
